import { render, staticRenderFns } from "./JournalPublistSearch.vue?vue&type=template&id=8830cb6a&"
import script from "./JournalPublistSearch.vue?vue&type=script&lang=js&"
export * from "./JournalPublistSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports